/*
 */
/**
 * 模块接口
 */

import codeRuleApi from './codeRuleApi';
import countryApi from './countryApi';
import afterSaleApi from './afterSaleApi';
import lovApi from './lovApi';
import configApi from './configApi';
import refreshServiceApi from './refreshServiceApi';
export default {
  ...codeRuleApi,
  ...countryApi,
  ...afterSaleApi,
  ...lovApi,
  ...configApi,
  ...refreshServiceApi,
};
